import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(p) { super(p); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error) { console.error("[corex] page crashed:", error); }
  render() {
    if (!this.state.error) return this.props.children;
    return (<div className="cx-card cx-card-static max-w-xl mx-auto mt-16 text-center space-y-3" data-testid="page-error-boundary">
      <AlertTriangle size={28} className="text-cx-amber mx-auto" />
      <div className="text-base font-semibold">This page hit a problem</div>
      <div className="text-sm text-cx-muted">{this.props.message || "Something went wrong while rendering. Your data is safe — try again."}</div>
      <pre className="cx-mono text-[11px] text-cx-muted bg-cx-elevated rounded-cx-sm p-2 text-left overflow-auto max-h-32" data-testid="page-error-detail">{String(this.state.error?.message || this.state.error)}</pre>
      <button className="cx-btn cx-btn-secondary cx-btn-sm" onClick={() => this.setState({ error: null })} data-testid="page-error-retry"><RefreshCw size={12} /> Retry</button>
    </div>);
  }
}
